import OpenDelayedComponent from "../components/openDelayed";
import { dateTimeFormat } from "../../../../../utils";
import { Dropdown, Space, Popconfirm } from "antd";
import More2LineIcon from "remixicon-react/More2LineIcon";
import DeleteBin6LineIcon from "remixicon-react/DeleteBin6LineIcon";

export const instrumentsTableCols = (onCalibrationClick, params, navigate, onDeleteInstrument) => [
  {
    title: "Instrument Name",
    dataIndex: ["instrument", "name"],
    key: "name",
    width: 150,
    minWidth: 100,
    fixed: "left",
    ellipsis: true,
    render: (text, record) => (
      <OpenDelayedComponent
        val={record}
        onCalibrationClick={onCalibrationClick}
        params={params}
        navigate={navigate}
      />
    ),
  },
  {
    title: "Serial Number",
    dataIndex: ["instrument", "code"],
    key: "code",
    width: 150,
    minWidth: 100,
    ellipsis: true,
    fixed: "left",
  },
  {
    title: "Make",
    dataIndex: ["instrument", "make"],
    key: "make",
    width: 120,
    minWidth: 100,
  },
  {
    title: "Location",
    dataIndex: ["instrument", "station", "name"],
    key: "name",
    width: 100,
    minWidth: 100,
  },
  // {
  //   title: "Last Calibrated Date",
  //   dataIndex: ["instrument", "lastCalibratedAt"],
  //   key: "lastCalibratedAt",
  //   width: 100,
  //   minWidth: 100,
  //   render: (text) => (text ? dateTimeFormat(text) : ""),
  // },
  {
    title: "Due Date",
    dataIndex: ["instrument", "dueDate"],
    key: "dueDate",
    width: 100,
    minWidth: 100,
    render: (text) => (text ? dateTimeFormat(text) : ""),
  },
  {
    title: "Actions",
    key: "actions",
    width: 60,
    minWidth: 60,
    fixed: "right",
    align: "center",
    render: (_, record) => {
      const items = [
        {
          key: 'delete',
          danger: true,
          label: (
            <Popconfirm
              title="Delete instrument"
              description="Are you sure to delete this instrument?"
              onConfirm={(e) => {
                e?.stopPropagation();
                onDeleteInstrument(record?.instrument?.id);
              }}
              onCancel={(e) => {
                e?.stopPropagation();
              }}
              okText="Yes"
              cancelText="No"
            >
              <span style={{ cursor: "pointer" }}>Delete Instrument</span>
            </Popconfirm>
          ),
          icon: <DeleteBin6LineIcon size="20px" />,
        },
      ];

      return (
        <Dropdown
          menu={{
            items,
          }}
          trigger={['click']}
        >
          <Space>
            <More2LineIcon style={{ cursor: "pointer" }} />
          </Space>
        </Dropdown>
      );
    },
  },
];
